var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.usuario)?_c('span',[_vm._v(" "+_vm._s(_vm.usuario.user_name)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }